exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".row__vehicle-module___1Zsud {\n  background-color: var(--color-new-light-background);\n  margin: 0;\n}\n\n@media (max-width: 768px) {\n  .row__vehicle-module___1Zsud {\n    flex-direction: column;\n  }\n}\n", ""]);

// Exports
exports.locals = {
	"row": "row__vehicle-module___1Zsud"
};